module.exports = __webpack_public_path__ + "static/media/Group 635.ce4054db.png";